import uniqid from 'uniqid';
import PropTypes from 'prop-types';
import GuestReview from './guestReview';
import HorizontalScroll from './horizontalScroll';
import './guestReviewNuggetList.scss';

const MAX_NR_OF_REVIEWS = 10;

const GuestReviewNuggetList = ({ reviews = [], labels, onClick }) => {
  const noHotelReviewInfo =
    (labels && labels.noHotelReviewInfo) || 'No reviews';

  if (!reviews || reviews.length < 1) {
    return (
      <div className="gw-guest-review-list__text-wrapper">
        <p className="gw-guest-review-list__placeholder-text">
          {noHotelReviewInfo}
        </p>
      </div>
    );
  }

  return (
    <HorizontalScroll stepSize={450}>
      {reviews.slice(0, MAX_NR_OF_REVIEWS).map((r) => {
        return (
          <div
            className="gw-guest-review-list-item"
            key={uniqid('gw-guest-review-list-item-')}
          >
            <GuestReview review={r} labels={labels} onClick={onClick} />
          </div>
        );
      })}
    </HorizontalScroll>
  );
};

GuestReviewNuggetList.propTypes = {
  labels: PropTypes.shape({
    noHotelReviewInfo: PropTypes.string,
  }).isRequired,
  reviews: PropTypes.arrayOf(
    PropTypes.shape({
      rating: PropTypes.number,
      maxRating: PropTypes.number,
      body: PropTypes.string,
      member: PropTypes.shape({
        id: PropTypes.string,
        alias: PropTypes.string,
      }),
      date: PropTypes.shape({
        long: PropTypes.string,
        raw: PropTypes.string,
      }),
    }),
  ),
  onClick: PropTypes.func.isRequired,
};

GuestReviewNuggetList.defaultProps = {
  reviews: [],
};

export default GuestReviewNuggetList;
